// extracted by mini-css-extract-plugin
module.exports = {"links":"MinimalFooter_links__7CavJ"};